import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-3 group"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/20 border border-primary-500/30 group-hover:border-primary-500/60 transition-colors">
              <i className="ri-moon-line text-xl text-primary-400"></i>
            </div>
            <span className="text-lg md:text-xl font-heading font-bold text-foreground-50 tracking-wider">
              邪娠娼馆
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-label transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 rounded-lg text-sm font-label transition-all duration-300 whitespace-nowrap text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 flex items-center gap-1">
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 w-48 bg-background-200 border border-background-300/60 rounded-lg shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 py-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block px-4 py-2.5 text-sm text-foreground-300 hover:text-foreground-100 hover:bg-background-300/50 transition-colors whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 text-primary-400`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-label transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-200 hover:bg-background-200/50 transition-colors"
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 pb-4 bg-background-100/95 backdrop-blur-md border-t border-background-300/30">
          <Link
            to="/"
            className={`block px-4 py-3 rounded-lg text-sm font-label transition-colors ${
              location.pathname === '/'
                ? 'text-primary-400 bg-primary-500/10'
                : 'text-foreground-300 hover:text-foreground-100'
            }`}
          >
            首页
          </Link>
          <div className="px-4 py-2 text-xs text-foreground-500 font-label uppercase tracking-wider mt-1">
            分类浏览
          </div>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="block px-4 py-2.5 text-sm text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 rounded-lg transition-colors"
            >
              <i className={`${cat.icon} mr-2 text-primary-400`}></i>
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`block px-4 py-3 rounded-lg text-sm font-label transition-colors mt-2 ${
              location.pathname === '/about'
                ? 'text-primary-400 bg-primary-500/10'
                : 'text-foreground-300 hover:text-foreground-100'
            }`}
          >
            关于我们
          </Link>
        </div>
      </div>
    </nav>
  );
}